import { useIsActivePrimeMember } from "~/clientState/hooks/useMembershipQuery";
import { useIsActivePrimeMarket } from "~/clientState/hooks/usePrimeSitePropertiesQuery";
import useShoppingBundleQuery from "~/clientState/hooks/useShoppingBundleQuery";
import {
  getPerksForFunnel,
  isValidPerks,
} from "~/clientState/hooks/utils/MembershipPerksUtils";
import { OnlineFunnel } from "~/constants/Funnel";

export interface MembershipAcquisitionFunnel {
  isAcquisitionFunnel: boolean;
  shouldRender: boolean;
  error: unknown;
}

const useMembershipAcquisitionFunnel = ({
  funnel = OnlineFunnel.FLIGHTS,
}): MembershipAcquisitionFunnel => {
  const { data: sBundleData, errors: sBundleErrors } = useShoppingBundleQuery();
  const isActivePrimeMarket = useIsActivePrimeMarket(funnel);
  const isActivePrimeMember = useIsActivePrimeMember();

  let error: unknown = null;
  let isValidPrimeDiscount = false;

  if (sBundleErrors) {
    error = sBundleErrors;
  }
  if (sBundleData?.getShoppingBundle) {
    const membershipPerks = sBundleData.getShoppingBundle.membershipPerks;
    const discount = getPerksForFunnel(membershipPerks, funnel);
    isValidPrimeDiscount = isValidPerks(discount);
  }

  const isPrimeEnabled =
    isActivePrimeMarket && isValidPrimeDiscount && !isActivePrimeMember;
  const isAcquisitionFunnel = isActivePrimeMarket && !isActivePrimeMember;

  return {
    error,
    isAcquisitionFunnel: isAcquisitionFunnel,
    shouldRender: isPrimeEnabled,
  };
};

export default useMembershipAcquisitionFunnel;
